import React, { Component } from "react";
import Field from "./Field";
import { Container } from "../../theme/styled";

class _28x15 extends Component {
  render() {
    return (
      <Container>
        <Field id="court" />
      </Container>
    );
  }
}

export default _28x15;
